import { render, staticRenderFns } from "./ModalAssignVoucher.vue?vue&type=template&id=94956dfe&"
import script from "./ModalAssignVoucher.vue?vue&type=script&lang=js&"
export * from "./ModalAssignVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports